(() => {
    'use strict';

    angular
        .module('uwAgenda.login')
        .controller(
            'ResetPasswordController',
            [
                'RegistrationService',
                'HelperService',
                '$stateParams',
                'AdministrationService',
                'Languages',
                ResetPasswordController
            ]
        );

    function ResetPasswordController(
        RegistrationService,
        HelperService,
        $stateParams,
        AdministrationService,
        Languages
    ) {
        let vm = this;

        vm.key = $stateParams.key;
        vm.id = $stateParams.id;
        let lid = parseInt($stateParams.lid);
        if (lid > 0 && lid < 5) {
            vm.languageId = lid;
        } else {
            vm.languageId = Languages.Dutch.id;
        }
        vm.showSuccessMessage = false;
        vm.errorMessageKey = '';
        vm.redirectToAgendaOwnerWebsiteUrls = [];
        vm.isPatient = false;
        AdministrationService.languages().then(result => {
            AdministrationService.setLanguage(result.find(language => language.id === vm.languageId));
            vm.languages = result;
        });

        vm.resetPassword = () => {
            HelperService.block(".content");
            vm.errorMessageKey = '';

            RegistrationService
                .resetPassword(
                    vm.key,
                    vm.password,
                    vm.passwordRepeated,
                    vm.id,
                ).then((passwordResetResult) => {
                    vm.errorMessageKey = passwordResetResult.errorMessageResourceKey;
                    vm.showSuccessMessage = passwordResetResult.success;
                    vm.isPatient = passwordResetResult.isPatient;
                    vm.redirectToAgendaOwnerWebsiteUrls = passwordResetResult.redirectToAgendaOwnerWebsiteUrls;
    
                    HelperService.unblock(".content");
                }, (error) => {
                    HelperService.unblock(".content");
                });
        };
    }
    
})(); 